import React from "react"
import { Button } from "../../../components/button/button"
import { useTracking } from "react-tracking"
import { getSubmissionTrackingString } from "../../app/functions"

import "./style.scss"

export const Actions = (props: {
    className?: string
    mobileDisplay: boolean
    submit: (type: "demo" | "signup") => void
}) => {
    const { className, mobileDisplay, submit } = props
    const { trackEvent } = useTracking()

    function trackedSubmit(value: "demo" | "signup") {
        const trackingValue = getSubmissionTrackingString(value)
        trackEvent({
            event: "genericEvent",
            category: "click",
            action: `click button`,
            label: `${trackingValue}`,
        })
        submit(value)
    }

    return (
        <div className={`sia-actions ${className ? className : ""}`}>
            <Button className={`sign-up ${mobileDisplay ? "mbl-hidden" : ""}`} onClick={() => trackedSubmit("signup")}>
                Sign up
            </Button>
            <div className="demo-body">
                Still not convinced?
                <Button className="demo" variant="primary-outline" onClick={() => trackedSubmit("demo")}>
                    Get a demo
                </Button>
            </div>
            <p>
                By selecting Sign up or Get a demo, you agree to our{" "}
                <a target="_blank" href="https://blackpearlmail.com/about/privacy-policy/">
                    Privacy&nbsp;Policy
                </a>
            </p>
        </div>
    )
}
